import { useState, type CSSProperties } from "react";
import { Link } from "react-router-dom";
import type { AgentTemplate } from "../../../pages/dashboard/mock";
import styles from "./TemplateCard.module.css";

type TemplateCardProps = {
  template: AgentTemplate;
};

const GLYPH_BY_SLUG: Record<string, string> = {
  "lead-generation": "✦",
  "email-automation": "✉",
  "db-reactivation": "↻",
  "voice-receptionist": "◐",
  "inbox-triage": "❖",
};

export const TemplateCard = ({ template }: TemplateCardProps): JSX.Element => {
  const [imageFailed, setImageFailed] = useState<boolean>(false);
  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  const showGlyph = imageFailed || !imageLoaded;
  const glyph = GLYPH_BY_SLUG[template.slug] ?? "◆";

  const gradientStyle: CSSProperties = {
    ["--gradient-from" as string]: template.gradientFrom,
    ["--gradient-to" as string]: template.gradientTo,
  };

  return (
    <Link
      to={`/dashboard/agents/${template.slug}`}
      className={styles.card}
      aria-label={`Open ${template.name}`}
    >
      <div className={styles.hero} style={gradientStyle}>
        <div className={styles.gradient} aria-hidden>
          {showGlyph ? <span className={styles.glyph}>{glyph}</span> : null}
        </div>
        {!imageFailed ? (
          <img
            src={template.imageUrl}
            alt=""
            className={styles.heroImage}
            onLoad={() => setImageLoaded(true)}
            onError={() => setImageFailed(true)}
            style={{ opacity: imageLoaded ? 1 : 0 }}
          />
        ) : null}
      </div>
      <div className={styles.body}>
        <h3 className={styles.title}>{template.name}</h3>
        <p className={styles.description}>{template.description}</p>
        <div className={styles.tagsRow}>
          {template.tags.map((tag) => (
            <span key={tag} className={styles.tag}>
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
};
